import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { Theme } from './models/theme.model';
import { DEFAULT_ION_COLORS, DEFAULT_ION_COLORS_VARIANTS, IonColorVariant } from './models/ionColor.model';

@Injectable({
	providedIn: 'root'
})
export class ThemeService {
	private readonly ION_COLOR_VAR_PREFIX = '--ion-color';

	constructor(@Inject(DOCUMENT) private document: Document) {}

	/**
	 * Creates a string of css variables for the default ionic colors and their variants(ie. primary-rgb).
	 * This string of variables is then applied to global css.
	 * @param theme 9 Default colors
	 * @returns String of css variables
	 * @see https://ionicframework.com/docs/theming/basics This is doing what the color generator does for 9 colors.
	 */
	public createIonColorPallete(theme: Theme): string {
		let cssVariables = '';

		DEFAULT_ION_COLORS.forEach((colorVariable) => {
			const variableName = this.ION_COLOR_VAR_PREFIX + `-${colorVariable}`;
			cssVariables = cssVariables.concat(this.createNewIonColor(variableName, theme[colorVariable]));
		});
		this.setGlobalCSS(cssVariables);

		return cssVariables;
	}

	public setGlobalVariablesFromConfig(globalVariables: string[]): void {
		globalVariables.forEach((variable) => {
			if (this.document.documentElement.style.getPropertyValue(variable.split(':')[0]) === '') {
				this.document.documentElement.style.cssText += variable;
			}
			this.document.documentElement.style.setProperty(variable.split(':')[0], variable.split(':')[1]);
		});
	}

	public setGlobalFontsFromConfig(globalFonts: string[]): void {
		globalFonts.forEach((variable) => {
			if (this.document.documentElement.style.getPropertyValue(variable.split(':')[0]) === '') {
				this.document.documentElement.style.cssText += variable;
			}
			this.document.documentElement.style.setProperty(variable.split(':')[0], variable.split(':')[1]);
		});
	}

	/**
	 * Creates all color variants given a variable name, and a string.
	 * @param variableName
	 * @param color The hex value color value to create variatns o
	 * @returns
	 */
	private createNewIonColor(variableName: string, color: string): string {
		let colorVariables = '';

		// Add base variable, no varition
		colorVariables = colorVariables.concat(variableName, ': ', color, '; ');

		DEFAULT_ION_COLORS_VARIANTS.forEach((variant) => {
			const variantColor = this.computeVariantColor(variant, color);

			if (variantColor != null) {
				colorVariables = colorVariables.concat(variableName, `-${variant}`, ': ', variantColor, '; ');
			}
		});
		return colorVariables;
	}

	/**
	 *
	 * @param variant
	 * @param color
	 * @returns
	 */
	private computeVariantColor(variant: IonColorVariant, color: string): string {
		let colorVariant: string = null;

		switch (variant) {
			case 'rgb': {
				const rgb = this.hexToRgb(color);
				if (rgb != null) {
					colorVariant = `${rgb.r}, ${rgb.g}, ${rgb.b}`;
				} else {
					console.log('Failed to create rgb variant for: ', color);
				}
				break;
			}
			case 'contrast':
				break;
			case 'contrast-rgb':
				break;
			case 'shade':
				break;
			case 'tint':
				break;
		}
		return colorVariant;
	}

	private setGlobalCSS(css: string) {
		this.document.documentElement.style.cssText = css;
	}

	/**
	 * Converts a hex color string to rgb color
	 * @param hex Hex color string
	 * @returns
	 * @see https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb Function was found here.
	 */
	private hexToRgb(hex: string): any {
		// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
		const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
		hex = hex.replace(shorthandRegex, function (m, r, g, b) {
			return r + r + g + g + b + b;
		});

		const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		return result
			? {
					r: parseInt(result[1], 16),
					g: parseInt(result[2], 16),
					b: parseInt(result[3], 16)
				}
			: null;
	}

	//   private contrast(color, ratio = 0.8) {
	//   //color = Color(color);
	//   //return color.isDark() ? color.lighten(ratio) : color.darken(ratio);
	// }
}
